<template>
  <button class="icon-button" :class="disabled ? 'disabled-button' : ''">
    <span class="button-text">{{ text }}</span>
    <van-image
      v-if="showIcon"
      class="button-icon"
      :src="require('@/assets/image/ic_arror_yellow.png')"
    />
  </button>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="css">
.icon-button {
  height: 134px;
  width: 100%;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 40px;
  background: #2C83F7;
  border: none;
  border-radius: 45px;
  cursor: pointer;
  position: relative;

  font-weight: 500;
  font-size: 32px;
  color: #FFFFFF;
  line-height: 40px;
  text-align: left;
  font-style: normal;
}

.disabled-button {
  background-color: #666666;
  cursor: not-allowed;
}

.button-text {
  flex-grow: 1;
  text-align: center;
}

.button-icon {
  height: 24px; /* Adjust icon size */
  width: 36px; /* Adjust icon size */
}
</style>
